// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'
import App from './App'
import router from './router'
import store from './store'
import './assets/myIncon/iconfont.css'
import '@/styles/index.css';
import "@/utils/directive"
import 'vue-ydui/dist/ydui.base.css';

// 全局提示框dialog
import { Confirm, Alert, Toast, Notify, Loading } from 'vue-ydui/dist/lib.rem/dialog';
Vue.prototype.$dialog = {
    confirm: Confirm,
    alert: Alert,
    toast: Toast,
    notify: Notify,
    loading: Loading,
};

import {Cell,Popup,Picker} from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.component(Popup.name, Popup);
Vue.component(Cell.name, Cell);
Vue.component(Picker.name, Picker);

import '@/lib/Extend/Date.Extend';

import Interface from './lib'

Vue.prototype.Interface = Interface

Vue.config.productionTip = false
const signalr=require("@microsoft/signalr")
const connection=new signalr.HubConnectionBuilder().withUrl("https://pma.arrcencloud.net:5001/userHub").configureLogging(signalr.LogLevel.Error).build()
Vue.prototype.$connection=connection
Vue.use(VueCompositionApi)
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js